import React, { useState, useEffect } from 'react';
import axiosInstance from '../networking/axiosconfig';

const IdentityCardFormat = ({ userData }) => {
  if (!userData) return null;
  console.log("userData", userData)

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (e) {
      return dateString;
    }
  };

  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith('http')) return imagePath;
    // Relative to the serving origin — keeps this protocol-agnostic so it
    // does not break as mixed content once the site is on HTTPS.
    return `${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
  };

  // TODO(multi-tenancy): this is one tenant's logo hardcoded. Source it from
  // the organization record (GET /api/organization) like login.js does.
  const organizationLogo = '/uploads/1758720302618-312666426.png';

  return (
    <div
      id="identity-card"
      className="bg-white relative overflow-hidden"
      style={{
        width: '340px',
        height: '540px',
        fontFamily: 'Arial, sans-serif',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
        borderRadius: '12px',
        WebkitPrintColorAdjust: 'exact',
        printColorAdjust: 'exact'
      }}
    >
      <style>
        {`
          @media print {
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            body {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
          }
        `}
      </style>
      {/* Top Blue Header Section */}
      <div className="relative flex items-center justify-center" style={{
        height: '140px',
        background: 'linear-gradient(135deg, #2563eb 0%, #1e40af 30%, #3b82f6 60%, #60a5fa 100%)',
        borderTopLeftRadius: '12px',
        borderTopRightRadius: '12px'
      }}>
        {/* Organization Name */}
        <div className="flex flex-col items-center justify-center relative z-10 w-full -mt-12">
          <div className="flex flex-col items-center leading-none gap-0.5">
            <span className="text-white font-black text-4xl tracking-widest drop-shadow-sm">INURUM</span>
            <div className="flex items-center gap-2 w-full mt-1">
              <div className="h-px flex-grow bg-blue-200 opacity-70"></div>
              <span className="text-blue-100 font-bold text-[10px] tracking-[0.3em] uppercase drop-shadow-sm">
                Technologies
              </span>
              <div className="h-px flex-grow bg-blue-200 opacity-70"></div>
            </div>
          </div>
        </div>

        {/* Wave Pattern at Bottom of Blue Section */}
        <svg
          className="absolute bottom-0 left-0 w-full bg-gradient-to-r"
          style={{ height: '40px' }}
          viewBox="0 0 340 40"
          preserveAspectRatio="none"
        >
          <path
            d="M0,20 Q85,0 170,20 T340,20 L340,40 L0,40 Z"
            fill="white"
          />
        </svg>


      </div>

      {/* White Content Section */}
      <div className="relative pt-12 pb-6 px-6" style={{ minHeight: '400px' }}>
        {/* Centered Profile Photo  */}
        <div className="flex justify-center -mt-24 mb-4">
          <div className="relative">
            <div className="w-32 h-32 rounded-full overflow-hidden border-2 border-white shadow-sm bg-gray-200" style={{ boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)' }}>
              {getImageUrl(userData.user_profile_img) ? (
                <img
                  src={getImageUrl(userData.user_profile_img)}
                  alt={`${userData.first_name || ''} ${userData.last_name || ''}`}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div
                className="w-full h-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white text-3xl font-bold"
                style={{ display: getImageUrl(userData.user_profile_img) ? 'none' : 'flex' }}
              >
                {(userData.first_name?.[0] || '') + (userData.last_name?.[0] || '')}
              </div>
            </div>
          </div>
        </div>

        {/* Employee Name */}
        <div className="text-center">
          <div className="text-2xl font-bold text-gray-900 ">
            {userData.first_name || ''} {userData.last_name || ''}
          </div>
          {userData.designation_name && (
            <div className="text-base text-gray-700 ">
              {userData.designation_name}
            </div>
          )}
          <div className="text-sm text-gray-700 font-medium">
            Employee ID : {userData.employeeId || 'N/A'}
          </div>
        </div>

        {/* Employee Details Section */}
        <div className="mt-6 space-y-2 px-4 text-sm">

          {userData.blood_group && (
            <div className="flex border-b border-gray-100 pb-2">
              <div className="w-36 font-semibold text-gray-900">Blood Group</div>
              <div className="w-4 text-center font-semibold">:</div>
              <div className="flex-1 text-gray-800">{userData.blood_group}</div>
            </div>
          )}

          {userData.mobile_number && (
            <div className="flex border-b border-gray-100 pb-2">
              <div className="w-36 font-semibold text-gray-900">Phone</div>
              <div className="w-4 text-center font-semibold">:</div>
              <div className="flex-1 text-gray-800">{userData.mobile_number}</div>
            </div>
          )}

          {userData.gender && (
            <div className="flex border-b border-gray-100 pb-2">
              <div className="w-36 font-semibold text-gray-900">Gender</div>
              <div className="w-4 text-center font-semibold">:</div>
              <div className="flex-1 text-gray-800 capitalize">{userData.gender}</div>
            </div>
          )}

          {userData.emergency_contact_no && (
            <div className="flex border-b border-gray-100 pb-2">
              <div className="w-36 font-semibold text-gray-900">
                Emergency Contact
              </div>
              <div className="w-4 text-center font-semibold">:</div>
              <div className="flex-1 text-gray-800">
                {userData.emergency_contact_no}
              </div>
            </div>
          )}

        </div>

      </div>

      {/* Bottom Wave Pattern */}
      <div className="absolute bottom-0 left-0 w-full" style={{ height: '60px', borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px', overflow: 'hidden' }}>
        <svg
          className="w-full h-full"
          viewBox="0 0 340 30"
          preserveAspectRatio="none"
        >
          <path
            d="M0,10 Q85,20 170,10 T340,10 L340,30 L0,30 Z"
            fill="#dbeafe"
          />
        </svg>
      </div>

      {/* Website Footer */}
      <div className="absolute bottom-2 left-0 right-0 text-center">
        <div className="text-xs font-semibold" style={{ color: '#1e40af' }}>
          www.inurum.com
        </div>
      </div>
    </div>
  );
};

export default IdentityCardFormat;


